import axios from 'axios';
import { logEvent } from './Logger';
import { API_URLS } from '../data/apiURLs';
import { Tag as TagType } from '../types/types';
export const suggestMoralArguments = async (originalComment: string, tags: TagType[], comment: string) => {
  try {
    const tags_text = tags.map((tag) => tag.frame).join(', ');
    const response = await axios.post(API_URLS.GENERATE_SUGGESTIONS, {
      original_post: originalComment,
      moral_frame: tags_text,
      draft: comment
    });

    await logEvent(
      'suggest_moral_arguments',
      JSON.stringify({ original_post: originalComment, frame: tags_text, draft: comment }),
      window.location.href
    );

    // Update the return statement to match the new data structure
    return response.data.ideas.map((item: { title: string; idea: string }) => ({
      title: item.title,
      idea: item.idea
    }));
  } catch (error) {
    console.error('Error fetching suggestions:', error);
    throw error;
  }
};

export const identifyLogicalFlaws = async (comment: string, tags: TagType[], originalComment: string) => {
  const tags_text = tags.map((tag) => tag.frame).join(', ');
  try {
    const response = await axios.post(API_URLS.FIND_LOGICAL_FLAWS, {
      draft: comment,
      frame: tags_text,
      original_post: originalComment
    });

    await logEvent(
      'identify_logical_flaws',
      JSON.stringify({ draft: comment, frame: tags_text, original_post: originalComment }),
      window.location.href
    );

    return response.data.ideas;
  } catch (error) {
    console.error('Error fetching logical flaws:', error);
    throw error;
  }
};

export const validateFrame = async (draft: string, targetFrame: string) => {
  try {
    const response = await axios.post(API_URLS.VALIDATE_FRAME, {
      draft,
      target_frame: targetFrame
    });

    await logEvent(
      'validate_frame',
      JSON.stringify({ draft, target_frame: targetFrame }),
      window.location.href
    );

    return {
      mainFrame: response.data.main_frame,
      isAligned: response.data.is_aligned,
      explanation: response.data.explanation,
      ideas: response.data.ideas
    };
  } catch (error) {
    console.error('Error validating frame:', error);
    throw error;
  }
};

export const validateFrameMini = async (draft: string, targetFrames: TagType[]) => {
  const targetFramesStr = targetFrames.map((tag) => tag.frame).join(', ');

  try {
    const response = await axios.post(API_URLS.VALIDATE_FRAME_MINI, {
      draft,
      target_frame: targetFramesStr
    });

    await logEvent(
      'validate_frame_mini',
      JSON.stringify({ draft, target_frame: targetFramesStr }),
      window.location.href
    );

    return {
      mainFrame: response.data.main_frame,
      isAligned: response.data.is_aligned,
      explanation: response.data.explanation
    };
  } catch (error) {
    console.error('Error validating frame (mini):', error);
    throw error;
  }
};

export const fetchCommentRoots = async () => {
  try {
    const response = await axios.get(API_URLS.COMMENT_ROOTS);
    
    await logEvent(
      'fetch_comment_roots',
      'Fetched comment roots',
      window.location.href
    );

    const data = response.data;
    
    // Instead of saving to a file, we'll store the data in localStorage
    // localStorage.setItem('commentTitles', JSON.stringify(data));

    console.log('Comment roots saved to localStorage');
    return data;
  } catch (error) {
    console.error('Error fetching comment roots:', error);
    throw error;
  }
};

// Function to retrieve comment roots from localStorage
export const getCommentRoots = () => {
  const data = localStorage.getItem('commentTitles');
  return data ? JSON.parse(data) : null;
};

export const fetchComment = async (commentId: number, username: string) => {
  try {
    const response = await axios.get(API_URLS.FETCH_COMMENT(commentId), {
      params: {
        username
      }
    });
    
    await logEvent(
      'fetch_comment',
      `Fetched comment with ID: ${commentId}`,
      window.location.href
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching comment:', error);
    throw error;
  }
};

// New function to send comments
export const sendComment = async (commentData: {
  title: string;
  username: string;
  is_user_created: boolean;
  is_visible: boolean;
  text: string;
  frames: string;
  parent_id: string;
}) => {
  try {
    const response = await axios.post(API_URLS.SEND_COMMENTS, commentData);

    await logEvent(
      'send_comment',
      JSON.stringify(commentData),
      window.location.href
    );

    return response.data;
  } catch (error) {
    console.error('Error sending comment:', error);
    throw error;
  }
};